import Body from "../components/layout/Body";
import FileList from "../components/FileList";
import PatientListingSidebar from "../components/layout/Sidebar/PatientListingSidebar";
import { useNavigate, useParams } from "react-router-dom";
import useApiHook from "../hooks/useApiHook";
import { useEffect, useMemo } from "react";
import { usePatientRefresh } from "../store/modal-context";

const PatientPage = () => {
    const { patientId } = useParams();
    const navigate = useNavigate();
    const { response, makeRequest, error } = useApiHook();
    const { patientsVersion } = usePatientRefresh();

    useEffect(() => {
        if (!patientId || patientId === 'noPatient') {
            return;
        }

        makeRequest(`/folder/${patientId}`);
    }, [patientId, patientsVersion, makeRequest]);

    useEffect(() => {
        if (patientId && patientId !== 'noPatient' && error) {
            navigate('/dashboard');
        }
    }, [error, patientId, navigate]);

    const pageTitle = useMemo(() => {
        if (patientId === 'noPatient') {
            return 'Senza paziente';
        }

        return response?.data?.name || 'Paziente';
    }, [patientId, response]);

    return (
        <Body mainElement={<FileList patientId={patientId} scope={patientId === 'noPatient' ? 'root' : null} title={pageTitle} currentPatientName={response?.data?.name || null} />} sideBar={<PatientListingSidebar />} />
    );
};

export default PatientPage;
